import {createApp} from 'vue'

import vueRegistry from "@/src/vueRegistry";
import 'highlight.js/styles/monokai.css';
import _ from "lodash-es";
import PrimeVue from 'primevue/config';
import Aura from '@primevue/themes/aura';
import {definePreset} from '@primevue/themes';

export const createVueApp = function (component) {
    const app = createApp(component)

    _.each(vueRegistry.services, service => {
        app.use(service);
    })
    _.each(vueRegistry.directives, (directive, directiveName) => {
        app.directive(directiveName, directive);
    })

    _.each(vueRegistry.components, (comp, componentName) => {
        app.component(componentName, comp);
    })

    const myPreset = definePreset(Aura, {
        semantic: {
            colorScheme: {
                light: {
                    surface: {
                        50: '#EDF4F2',
                        100: '#EDF2F4',
                    },
                    primary: {
                        color: '#FF6101',
                        hoverColor: '#FF6101',
                        activeColor: '#C76200'
                    },
                    highlight: {
                        background: '#FF610199',
                        focusBackground: '#FF610199',
                        color: '#ffffff',
                        focusColor: '#ffffff'
                    }
                },
                dark: {
                    background: 'rgb(248, 250, 252)'
                }
            }
        },
        components: {
            button: {
                colorScheme: {
                    light: {
                        root: {
                            primary: {
                                background: 'black',
                                borderColor: 'black'
                            }
                        }
                    }
                }
            }
        }
    });
 
    function _getCspNonce() {
        if (typeof document === 'undefined') return null;
        try {
            const meta = document.querySelector && document.querySelector('meta[name="csp-nonce"]');
            return (meta && meta.getAttribute('content')) || (window && window.__cspNonce) || null;
        } catch (e) {
            return null;
        }
    }

    const _nonce = _getCspNonce();

    app.use(PrimeVue, {
        csp: {
            nonce: _nonce || undefined
        },
        theme: {
            preset: myPreset,
            options: {
                darkModeSelector: false, //also need darkMode: 'selector' in tailwind.config.js
            }
        }
    })

    return app;
}

export const staticImageSrc = (filename) => {
    if (import.meta.env.VITE_SERVICE_IMAGE_TAG) {
        const b = import.meta.env.VITE_BASE_URL.replace('/portal/api', '')
        return `${b}/public/${import.meta.env.VITE_SERVICE_IMAGE_TAG}/static/portal/dist/${filename}`
    }
    return filename
}
